import { Icon } from '../../shared/Icon';
import { navigationFor, type ViewName } from './navigation';

interface Props {
  activeView: ViewName;
  features: string[];
  onNavigate: (view: ViewName) => void;
}

export function MobileNav({ activeView, features, onNavigate }: Props) {
  const items = navigationFor(features);
  return <nav className={`mobile-nav ${items.length === 4 ? 'four-items' : ''}`} aria-label="Mobilmeny">
    {items.map(item => <button key={item.view} className={activeView === item.view ? 'active' : ''} onClick={() => onNavigate(item.view)}>
      <Icon name={item.icon} /><span>{item.label}</span>
    </button>)}
  </nav>;
}
